import { render, staticRenderFns } from "./VehicleOffer.vue?vue&type=template&id=66a5043c&scoped=true&"
import script from "./VehicleOffer.vue?vue&type=script&lang=js&"
export * from "./VehicleOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5043c",
  null
  
)

export default component.exports